const browser = {
	isChrome : !!window.chrome,
	isFirefox : !!window.sidebar,
	isIE11 : '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style,
	isIE10 : !!window.ActiveXObject,
	isOpera : /^function \(/.test([].sort),
	isSafari : /constructor/i.test(window.HTMLElement),
}

export default browser;